import React, { FC, useEffect } from "react";
import { toast, Toaster as HotToaster, useToasterStore } from 'react-hot-toast';
import { useTheme, fade } from "@material-ui/core";
import { corporate } from "../theme";

export const Toaster: FC = () => {
  const theme = useTheme();
  const { toasts } = useToasterStore();

  const maxNumberToasts = 3;

  useEffect(() => {
    toasts
      .filter((t) => t.visible)
      .filter((_, i) => i >= maxNumberToasts)
      .forEach((t) => toast.remove(t.id));
  }, [toasts]);

  return (
    <HotToaster
      position="bottom-center"
      toastOptions={{
        style: {
          backdropFilter: 'blur(6px)',
          background: fade(corporate.blue, 0.8),
          color: theme.palette.common.white,
          boxShadow: theme.shadows[16],
          wordBreak: "break-all"
        }
      }}
    />
  );
};
